
import Vue from 'vue';

export default Vue.extend({
  computed: {
    includeArchivedWidgets(): boolean {
      return this.$store.state.insights.filters.includeArchivedWidgets;
    },
  },
  mounted() {
    const q = this.$route.query;
    if (q.includeArchivedWidgets) {
      if (
        q.includeArchivedWidgets === 'true' ||
        // @ts-ignore
        q.includeArchivedWidgets === true
      ) {
        this.$store.dispatch('insights/setIncludeArchivedWidgets', true);
      } else {
        this.$store.dispatch('insights/setIncludeArchivedWidgets', false);
      }
    }
  },
  methods: {
    toogleIncludeArchivedWidgets() {
      const newValue = !this.$store.state.insights.filters
        .includeArchivedWidgets;
      this.$store.dispatch('insights/setIncludeArchivedWidgets', newValue);
      this.$store.dispatch('insights/setClearWidgets', true);
      this.$router.push({
        query: Object.assign({}, this.$route.query, {
          includeArchivedWidgets: newValue,
        }),
      });
    },
  },
});
